import { API_HOSTNAME } from '@/config';

const DEFAULT_SELF_HOSTED_API = 'http://localhost:3000';
const LOCAL_FALLBACK_PORTS: Record<string, string> = {
  '3000': '3010',
  '3010': '3000',
};
const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);

function normalizeBaseApiHostname(hostname?: string): string {
  return (hostname || API_HOSTNAME || DEFAULT_SELF_HOSTED_API).replace(/\/+$/, '');
}

function buildLocalFallbackHostname(primary: string): string | undefined {
  try {
    const parsed = new URL(primary);
    const port = parsed.port || (parsed.protocol === 'https:' ? '443' : '80');

    if (!LOCAL_HOSTS.has(parsed.hostname)) {
      return undefined;
    }

    const fallbackPort = LOCAL_FALLBACK_PORTS[port];
    if (!fallbackPort) {
      return undefined;
    }

    parsed.port = fallbackPort;

    return parsed.toString().replace(/\/+$/, '');
  } catch {
    return undefined;
  }
}

export function getApiHostnameCandidates(hostname?: string): string[] {
  const primary = normalizeBaseApiHostname(hostname);
  const fallback = buildLocalFallbackHostname(primary);

  if (!fallback || fallback === primary) {
    return [primary];
  }

  return [primary, fallback];
}
